export const Types = {
    GET_AREA_GROUP_LIST: "GET_AREA_GROUP_LIST",
    SET_AREA_GROUP_LIST: "SET_AREA_GROUP_LIST",

    GET_MAIN_EQUIPMENT_LIST: "GET_MAIN_EQUIPMENT_LIST",
    SET_MAIN_EQUIPMENT_LIST: "SET_MAIN_EQUIPMENT_LIST",

    GET_SUB_EQUIPMENT_LIST: "GET_SUB_EQUIPMENT_LIST",
    SET_SUB_EQUIPMENT_LIST: "SET_SUB_EQUIPMENT_LIST",

    GET_SUB_EQUIPMENTS_TASK_LIST: "GET_SUB_EQUIPMENTS_TASK_LIST",
    SET_SUB_EQUIPMENTS_TASK_LIST: "SET_SUB_EQUIPMENTS_TASK_LIST",

    GET_BREAKDOWN_REASON_GROUP_DATA: "GET_BREAKDOWN_REASON_GROUP_DATA",
    SET_BREAKDOWN_REASON_GROUP_DATA: "SET_BREAKDOWN_REASON_GROUP_DATA",
    
    GET_BREAKDOWN_REASON_PLACE_DATA: "GET_BREAKDOWN_REASON_PLACE_DATA",
    SET_BREAKDOWN_REASON_PLACE_DATA: "SET_BREAKDOWN_REASON_PLACE_DATA",
    
    GET_BREAKDOWN_EFFECT_DATA: "GET_BREAKDOWN_EFFECT_DATA",
    SET_BREAKDOWN_EFFECT_DATA: "SET_BREAKDOWN_EFFECT_DATA",
    
    GET_BREAKDOWN_ROOT_CAUSE_DATA: "GET_BREAKDOWN_ROOT_CAUSE_DATA",
    SET_BREAKDOWN_ROOT_CAUSE_DATA: "SET_BREAKDOWN_ROOT_CAUSE_DATA",

    GET_POOL_DATA: "GET_POOL_DATA",
    SET_POOL_DATA: "SET_POOL_DATA",
}

export const getAreaGroupList = (payload) => ({
    type: Types.GET_AREA_GROUP_LIST,
    payload,
});

export const setAreaGroupList = (payload) => ({
    type: Types.SET_AREA_GROUP_LIST,
    payload,
});

export const getMainEquipmentList = (payload) => ({
    type: Types.GET_MAIN_EQUIPMENT_LIST,
    payload,
});

export const setMainEquipmentList = (payload) => ({
    type: Types.SET_MAIN_EQUIPMENT_LIST,
    payload,
});

export const getSubEquipmentList = (payload) => ({
    type: Types.GET_SUB_EQUIPMENT_LIST,
    payload,
});

export const setSubEquipmentList = (payload) => ({
    type: Types.SET_SUB_EQUIPMENT_LIST,
    payload,
});

export const getSubEquipmentsTaskList = (payload) => ({
    type: Types.GET_SUB_EQUIPMENTS_TASK_LIST,
    payload,
});

export const setSubEquipmentsTaskList = (payload) => ({
    type: Types.SET_SUB_EQUIPMENTS_TASK_LIST,
    payload,
});

export const getBreakDownReasonGroupData = () => ({
    type: Types.GET_BREAKDOWN_REASON_GROUP_DATA,
});

export const setBreakdownReasonGroupData = (payload) => ({
    type: Types.SET_BREAKDOWN_REASON_GROUP_DATA,
    payload,
});

export const getBreakdownReasonPlaceData = () => ({
    type: Types.GET_BREAKDOWN_REASON_PLACE_DATA,
});

export const setBreakdownReasonPlaceData = (payload) => ({
    type: Types.SET_BREAKDOWN_REASON_PLACE_DATA,
    payload,
});

export const getBreakdownEffectData = () => ({
    type: Types.GET_BREAKDOWN_EFFECT_DATA,
});

export const setBreakdownEffectData = (payload) => ({
    type: Types.SET_BREAKDOWN_EFFECT_DATA,
    payload,
});

export const getBreakdownRootCauseData = () => ({
    type: Types.GET_BREAKDOWN_ROOT_CAUSE_DATA,
});

export const setBreakdownRootCauseData = (payload) => ({
    type: Types.SET_BREAKDOWN_ROOT_CAUSE_DATA,
    payload,
});

export const getPoolData = () => ({
    type: Types.GET_POOL_DATA,
});

export const setPoolData = (payload) => ({
    type: Types.SET_POOL_DATA,
    payload,
});

